import { ZestimateTableData } from '../ZestimateTable/ZestimateTable';

/**
 * Zestimate accuracy data for on-market (active listings) homes
 */
export const ZESTIMATE_DATA_ON_MARKET: Record<string, ZestimateTableData> = {
    'Top Metro Areas': {
        headers: [
            'Metropolitan Area',
            'Median Error<sup>*</sup>',
            'Homes With Zestimates<sup>**</sup>',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                'Metropolitan Area': 'Atlanta',
                'Median Error': '1.48%',
                'Homes With Zestimates': '49.7 K',
                'Within 5% of Sale Price': '88.42%',
                'Within 10% of Sale Price': '96.59%',
                'Within 20% of Sale Price': '99.00%',
            },
            {
                'Metropolitan Area': 'Austin',
                'Median Error': '1.83%',
                'Homes With Zestimates': '25.5 K',
                'Within 5% of Sale Price': '85.71%',
                'Within 10% of Sale Price': '96.02%',
                'Within 20% of Sale Price': '99.26%',
            },
            {
                'Metropolitan Area': 'Baltimore',
                'Median Error': '1.72%',
                'Homes With Zestimates': '10.8 K',
                'Within 5% of Sale Price': '85.82%',
                'Within 10% of Sale Price': '95.73%',
                'Within 20% of Sale Price': '98.69%',
            },
            {
                'Metropolitan Area': 'Boston',
                'Median Error': '2.45%',
                'Homes With Zestimates': '14.9 K',
                'Within 5% of Sale Price': '77.33%',
                'Within 10% of Sale Price': '94.88%',
                'Within 20% of Sale Price': '99.43%',
            },
            {
                'Metropolitan Area': 'Charlotte',
                'Median Error': '1.46%',
                'Homes With Zestimates': '19.8 K',
                'Within 5% of Sale Price': '89.63%',
                'Within 10% of Sale Price': '97.22%',
                'Within 20% of Sale Price': '99.29%',
            },
            {
                'Metropolitan Area': 'Chicago',
                'Median Error': '1.97%',
                'Homes With Zestimates': '42.3 K',
                'Within 5% of Sale Price': '83.40%',
                'Within 10% of Sale Price': '95.93%',
                'Within 20% of Sale Price': '99.13%',
            },
            {
                'Metropolitan Area': 'Cincinnati',
                'Median Error': '1.90%',
                'Homes With Zestimates': '9.7 K',
                'Within 5% of Sale Price': '84.58%',
                'Within 10% of Sale Price': '96.12%',
                'Within 20% of Sale Price': '99.06%',
            },
            {
                'Metropolitan Area': 'Cleveland',
                'Median Error': '2.45%',
                'Homes With Zestimates': '8.6 K',
                'Within 5% of Sale Price': '77.49%',
                'Within 10% of Sale Price': '94.32%',
                'Within 20% of Sale Price': '98.84%',
            },
            {
                'Metropolitan Area': 'Colorado Springs',
                'Median Error': '1.11%',
                'Homes With Zestimates': '6.8 K',
                'Within 5% of Sale Price': '94.18%',
                'Within 10% of Sale Price': '98.41%',
                'Within 20% of Sale Price': '99.62%',
            },
            {
                'Metropolitan Area': 'Dallas-Fort Worth',
                'Median Error': '1.68%',
                'Homes With Zestimates': '76.4 K',
                'Within 5% of Sale Price': '87.59%',
                'Within 10% of Sale Price': '96.41%',
                'Within 20% of Sale Price': '99.07%',
            },
            {
                'Metropolitan Area': 'Denver',
                'Median Error': '1.22%',
                'Homes With Zestimates': '22.9 K',
                'Within 5% of Sale Price': '93.02%',
                'Within 10% of Sale Price': '98.32%',
                'Within 20% of Sale Price': '99.63%',
            },
            {
                'Metropolitan Area': 'Detroit',
                'Median Error': '2.30%',
                'Homes With Zestimates': '14.7 K',
                'Within 5% of Sale Price': '79.30%',
                'Within 10% of Sale Price': '94.45%',
                'Within 20% of Sale Price': '98.62%',
            },
            {
                'Metropolitan Area': 'Fort Collins',
                'Median Error': '1.15%',
                'Homes With Zestimates': '3.3 K',
                'Within 5% of Sale Price': '93.61%',
                'Within 10% of Sale Price': '98.54%',
                'Within 20% of Sale Price': '99.65%',
            },
            {
                'Metropolitan Area': 'Houston',
                'Median Error': '1.93%',
                'Homes With Zestimates': '60.0 K',
                'Within 5% of Sale Price': '83.87%',
                'Within 10% of Sale Price': '94.65%',
                'Within 20% of Sale Price': '98.51%',
            },
            {
                'Metropolitan Area': 'Jacksonville',
                'Median Error': '1.73%',
                'Homes With Zestimates': '19.0 K',
                'Within 5% of Sale Price': '85.90%',
                'Within 10% of Sale Price': '95.34%',
                'Within 20% of Sale Price': '98.58%',
            },
            {
                'Metropolitan Area': 'Kansas City',
                'Median Error': '1.77%',
                'Homes With Zestimates': '10.7 K',
                'Within 5% of Sale Price': '85.94%',
                'Within 10% of Sale Price': '96.58%',
                'Within 20% of Sale Price': '99.27%',
            },
            {
                'Metropolitan Area': 'Las Vegas',
                'Median Error': '1.23%',
                'Homes With Zestimates': '18.5 K',
                'Within 5% of Sale Price': '92.36%',
                'Within 10% of Sale Price': '97.78%',
                'Within 20% of Sale Price': '99.39%',
            },
            {
                'Metropolitan Area': 'Los Angeles-Long Beach-Anaheim',
                'Median Error': '2.05%',
                'Homes With Zestimates': '31.6 K',
                'Within 5% of Sale Price': '81.21%',
                'Within 10% of Sale Price': '94.79%',
                'Within 20% of Sale Price': '99.01%',
            },
            {
                'Metropolitan Area': 'Miami-Fort Lauderdale',
                'Median Error': '2.16%',
                'Homes With Zestimates': '70.8 K',
                'Within 5% of Sale Price': '82.41%',
                'Within 10% of Sale Price': '94.78%',
                'Within 20% of Sale Price': '98.69%',
            },
            {
                'Metropolitan Area': 'Minneapolis-St Paul',
                'Median Error': '1.68%',
                'Homes With Zestimates': '18.2 K',
                'Within 5% of Sale Price': '87.47%',
                'Within 10% of Sale Price': '97.45%',
                'Within 20% of Sale Price': '99.42%',
            },
            {
                'Metropolitan Area': 'Nashville',
                'Median Error': '1.40%',
                'Homes With Zestimates': '21.3 K',
                'Within 5% of Sale Price': '88.78%',
                'Within 10% of Sale Price': '96.18%',
                'Within 20% of Sale Price': '98.90%',
            },
            {
                'Metropolitan Area': 'New York',
                'Median Error': '2.83%',
                'Homes With Zestimates': '64.9 K',
                'Within 5% of Sale Price': '72.07%',
                'Within 10% of Sale Price': '92.35%',
                'Within 20% of Sale Price': '98.72%',
            },
            {
                'Metropolitan Area': 'Orlando',
                'Median Error': '1.61%',
                'Homes With Zestimates': '25.9 K',
                'Within 5% of Sale Price': '88.70%',
                'Within 10% of Sale Price': '96.77%',
                'Within 20% of Sale Price': '99.08%',
            },
            {
                'Metropolitan Area': 'Philadelphia',
                'Median Error': '2.33%',
                'Homes With Zestimates': '21.2 K',
                'Within 5% of Sale Price': '77.84%',
                'Within 10% of Sale Price': '93.22%',
                'Within 20% of Sale Price': '98.36%',
            },
            {
                'Metropolitan Area': 'Phoenix',
                'Median Error': '1.26%',
                'Homes With Zestimates': '38.4 K',
                'Within 5% of Sale Price': '91.85%',
                'Within 10% of Sale Price': '98.01%',
                'Within 20% of Sale Price': '99.50%',
            },
            {
                'Metropolitan Area': 'Pittsburgh',
                'Median Error': '2.39%',
                'Homes With Zestimates': '8.2 K',
                'Within 5% of Sale Price': '77.65%',
                'Within 10% of Sale Price': '93.60%',
                'Within 20% of Sale Price': '98.74%',
            },
            {
                'Metropolitan Area': 'Portland',
                'Median Error': '1.39%',
                'Homes With Zestimates': '14.9 K',
                'Within 5% of Sale Price': '90.09%',
                'Within 10% of Sale Price': '97.56%',
                'Within 20% of Sale Price': '99.38%',
            },
            {
                'Metropolitan Area': 'Raleigh',
                'Median Error': '1.14%',
                'Homes With Zestimates': '12.1 K',
                'Within 5% of Sale Price': '92.99%',
                'Within 10% of Sale Price': '98.38%',
                'Within 20% of Sale Price': '99.62%',
            },
            {
                'Metropolitan Area': 'Riverside',
                'Median Error': '1.58%',
                'Homes With Zestimates': '22.6 K',
                'Within 5% of Sale Price': '87.27%',
                'Within 10% of Sale Price': '96.12%',
                'Within 20% of Sale Price': '98.41%',
            },
            {
                'Metropolitan Area': 'Sacramento',
                'Median Error': '1.55%',
                'Homes With Zestimates': '11.7 K',
                'Within 5% of Sale Price': '88.12%',
                'Within 10% of Sale Price': '96.60%',
                'Within 20% of Sale Price': '99.15%',
            },
            {
                'Metropolitan Area': 'San Antonio',
                'Median Error': '1.65%',
                'Homes With Zestimates': '26.6 K',
                'Within 5% of Sale Price': '86.17%',
                'Within 10% of Sale Price': '95.29%',
                'Within 20% of Sale Price': '98.64%',
            },
            {
                'Metropolitan Area': 'San Diego',
                'Median Error': '1.73%',
                'Homes With Zestimates': '12.1 K',
                'Within 5% of Sale Price': '86.63%',
                'Within 10% of Sale Price': '96.21%',
                'Within 20% of Sale Price': '98.98%',
            },
            {
                'Metropolitan Area': 'San Francisco',
                'Median Error': '3.08%',
                'Homes With Zestimates': '12.1 K',
                'Within 5% of Sale Price': '68.08%',
                'Within 10% of Sale Price': '89.24%',
                'Within 20% of Sale Price': '97.97%',
            },
            {
                'Metropolitan Area': 'Seattle',
                'Median Error': '1.58%',
                'Homes With Zestimates': '19.0 K',
                'Within 5% of Sale Price': '87.51%',
                'Within 10% of Sale Price': '96.77%',
                'Within 20% of Sale Price': '99.49%',
            },
            {
                'Metropolitan Area': 'St. Louis',
                'Median Error': '2.24%',
                'Homes With Zestimates': '10.2 K',
                'Within 5% of Sale Price': '80.25%',
                'Within 10% of Sale Price': '94.90%',
                'Within 20% of Sale Price': '98.91%',
            },
            {
                'Metropolitan Area': 'Tampa',
                'Median Error': '1.82%',
                'Homes With Zestimates': '34.7 K',
                'Within 5% of Sale Price': '86.12%',
                'Within 10% of Sale Price': '95.71%',
                'Within 20% of Sale Price': '98.68%',
            },
            {
                'Metropolitan Area': 'Tucson',
                'Median Error': '1.40%',
                'Homes With Zestimates': '7.4 K',
                'Within 5% of Sale Price': '91.07%',
                'Within 10% of Sale Price': '97.92%',
                'Within 20% of Sale Price': '99.55%',
            },
            {
                'Metropolitan Area': 'Washington',
                'Median Error': '1.46%',
                'Homes With Zestimates': '27.5 K',
                'Within 5% of Sale Price': '89.17%',
                'Within 10% of Sale Price': '97.75%',
                'Within 20% of Sale Price': '99.48%',
            },
        ],
    },
    States: {
        headers: [
            'State',
            'Median Error<sup>*</sup>',
            'Homes With Zestimates<sup>**</sup>',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                State: 'Alabama',
                'Median Error': '1.76%',
                'Homes With Zestimates': '32.1 K',
                'Within 5% of Sale Price': '84.07%',
                'Within 10% of Sale Price': '94.89%',
                'Within 20% of Sale Price': '98.46%',
            },
            {
                State: 'Alaska',
                'Median Error': 'NA',
                'Homes With Zestimates': '5.8 K',
                'Within 5% of Sale Price': 'NA',
                'Within 10% of Sale Price': 'NA',
                'Within 20% of Sale Price': 'NA',
            },
            {
                State: 'Arizona',
                'Median Error': '1.35%',
                'Homes With Zestimates': '58.0 K',
                'Within 5% of Sale Price': '90.85%',
                'Within 10% of Sale Price': '97.66%',
                'Within 20% of Sale Price': '99.40%',
            },
            {
                State: 'Arkansas',
                'Median Error': '1.86%',
                'Homes With Zestimates': '18.3 K',
                'Within 5% of Sale Price': '83.04%',
                'Within 10% of Sale Price': '94.17%',
                'Within 20% of Sale Price': '98.07%',
            },
            {
                State: 'California',
                'Median Error': '1.85%',
                'Homes With Zestimates': '133.7 K',
                'Within 5% of Sale Price': '83.20%',
                'Within 10% of Sale Price': '95.10%',
                'Within 20% of Sale Price': '98.77%',
            },
            {
                State: 'Colorado',
                'Median Error': '1.27%',
                'Homes With Zestimates': '51.0 K',
                'Within 5% of Sale Price': '91.89%',
                'Within 10% of Sale Price': '97.89%',
                'Within 20% of Sale Price': '99.47%',
            },
            {
                State: 'Connecticut',
                'Median Error': '3.02%',
                'Homes With Zestimates': '11.7 K',
                'Within 5% of Sale Price': '70.40%',
                'Within 10% of Sale Price': '92.29%',
                'Within 20% of Sale Price': '99.02%',
            },
            {
                State: 'Delaware',
                'Median Error': '2.11%',
                'Homes With Zestimates': '4.9 K',
                'Within 5% of Sale Price': '76.17%',
                'Within 10% of Sale Price': '87.81%',
                'Within 20% of Sale Price': '95.88%',
            },
            {
                State: 'District of Columbia',
                'Median Error': '1.71%',
                'Homes With Zestimates': '4.9 K',
                'Within 5% of Sale Price': '86.29%',
                'Within 10% of Sale Price': '96.58%',
                'Within 20% of Sale Price': '99.23%',
            },
            {
                State: 'Florida',
                'Median Error': '1.92%',
                'Homes With Zestimates': '284.0 K',
                'Within 5% of Sale Price': '84.73%',
                'Within 10% of Sale Price': '95.39%',
                'Within 20% of Sale Price': '98.72%',
            },
            {
                State: 'Georgia',
                'Median Error': '1.54%',
                'Homes With Zestimates': '79.2 K',
                'Within 5% of Sale Price': '87.27%',
                'Within 10% of Sale Price': '96.06%',
                'Within 20% of Sale Price': '98.76%',
            },
            {
                State: 'Hawaii',
                'Median Error': '1.85%',
                'Homes With Zestimates': '9.9 K',
                'Within 5% of Sale Price': '84.27%',
                'Within 10% of Sale Price': '95.61%',
                'Within 20% of Sale Price': '99.18%',
            },
            {
                State: 'Idaho',
                'Median Error': '1.30%',
                'Homes With Zestimates': '18.3 K',
                'Within 5% of Sale Price': '90.64%',
                'Within 10% of Sale Price': '97.38%',
                'Within 20% of Sale Price': '99.32%',
            },
            {
                State: 'Illinois',
                'Median Error': '2.12%',
                'Homes With Zestimates': '50.0 K',
                'Within 5% of Sale Price': '81.44%',
                'Within 10% of Sale Price': '95.30%',
                'Within 20% of Sale Price': '98.93%',
            },
            {
                State: 'Indiana',
                'Median Error': '1.80%',
                'Homes With Zestimates': '30.0 K',
                'Within 5% of Sale Price': '84.71%',
                'Within 10% of Sale Price': '95.46%',
                'Within 20% of Sale Price': '98.89%',
            },
            {
                State: 'Iowa',
                'Median Error': '1.72%',
                'Homes With Zestimates': '15.5 K',
                'Within 5% of Sale Price': '85.26%',
                'Within 10% of Sale Price': '95.90%',
                'Within 20% of Sale Price': '98.97%',
            },
            {
                State: 'Kansas',
                'Median Error': '1.98%',
                'Homes With Zestimates': '12.1 K',
                'Within 5% of Sale Price': '82.92%',
                'Within 10% of Sale Price': '95.64%',
                'Within 20% of Sale Price': '99.05%',
            },
            {
                State: 'Kentucky',
                'Median Error': '1.87%',
                'Homes With Zestimates': '19.1 K',
                'Within 5% of Sale Price': '84.47%',
                'Within 10% of Sale Price': '95.60%',
                'Within 20% of Sale Price': '98.77%',
            },
            {
                State: 'Louisiana',
                'Median Error': '1.88%',
                'Homes With Zestimates': '23.8 K',
                'Within 5% of Sale Price': '84.01%',
                'Within 10% of Sale Price': '94.85%',
                'Within 20% of Sale Price': '98.32%',
            },
            {
                State: 'Maine',
                'Median Error': '2.53%',
                'Homes With Zestimates': '8.2 K',
                'Within 5% of Sale Price': '75.25%',
                'Within 10% of Sale Price': '92.77%',
                'Within 20% of Sale Price': '98.30%',
            },
            {
                State: 'Maryland',
                'Median Error': '1.62%',
                'Homes With Zestimates': '25.6 K',
                'Within 5% of Sale Price': '86.26%',
                'Within 10% of Sale Price': '96.16%',
                'Within 20% of Sale Price': '98.92%',
            },
            {
                State: 'Massachusetts',
                'Median Error': '2.47%',
                'Homes With Zestimates': '21.9 K',
                'Within 5% of Sale Price': '77.49%',
                'Within 10% of Sale Price': '94.86%',
                'Within 20% of Sale Price': '99.36%',
            },
            {
                State: 'Michigan',
                'Median Error': '2.30%',
                'Homes With Zestimates': '38.0 K',
                'Within 5% of Sale Price': '78.72%',
                'Within 10% of Sale Price': '94.05%',
                'Within 20% of Sale Price': '98.59%',
            },
            {
                State: 'Minnesota',
                'Median Error': '1.82%',
                'Homes With Zestimates': '27.0 K',
                'Within 5% of Sale Price': '85.43%',
                'Within 10% of Sale Price': '96.57%',
                'Within 20% of Sale Price': '99.23%',
            },
            {
                State: 'Mississippi',
                'Median Error': '1.77%',
                'Homes With Zestimates': '11.5 K',
                'Within 5% of Sale Price': '84.40%',
                'Within 10% of Sale Price': '95.15%',
                'Within 20% of Sale Price': '98.67%',
            },
            {
                State: 'Missouri',
                'Median Error': '2.05%',
                'Homes With Zestimates': '30.4 K',
                'Within 5% of Sale Price': '82.09%',
                'Within 10% of Sale Price': '95.16%',
                'Within 20% of Sale Price': '98.79%',
            },
            {
                State: 'Montana',
                'Median Error': '1.96%',
                'Homes With Zestimates': '7.8 K',
                'Within 5% of Sale Price': '83.30%',
                'Within 10% of Sale Price': '94.99%',
                'Within 20% of Sale Price': '98.90%',
            },
            {
                State: 'Nebraska',
                'Median Error': '1.56%',
                'Homes With Zestimates': '9.0 K',
                'Within 5% of Sale Price': '87.59%',
                'Within 10% of Sale Price': '96.55%',
                'Within 20% of Sale Price': '99.09%',
            },
            {
                State: 'Nevada',
                'Median Error': '1.26%',
                'Homes With Zestimates': '24.6 K',
                'Within 5% of Sale Price': '91.64%',
                'Within 10% of Sale Price': '97.63%',
                'Within 20% of Sale Price': '99.38%',
            },
            {
                State: 'New Hampshire',
                'Median Error': '2.29%',
                'Homes With Zestimates': '6.4 K',
                'Within 5% of Sale Price': '78.71%',
                'Within 10% of Sale Price': '94.27%',
                'Within 20% of Sale Price': '98.87%',
            },
            {
                State: 'New Jersey',
                'Median Error': '2.78%',
                'Homes With Zestimates': '35.2 K',
                'Within 5% of Sale Price': '72.83%',
                'Within 10% of Sale Price': '92.94%',
                'Within 20% of Sale Price': '98.99%',
            },
            {
                State: 'New Mexico',
                'Median Error': '1.59%',
                'Homes With Zestimates': '10.6 K',
                'Within 5% of Sale Price': '87.48%',
                'Within 10% of Sale Price': '96.46%',
                'Within 20% of Sale Price': '99.11%',
            },
            {
                State: 'New York',
                'Median Error': '3.02%',
                'Homes With Zestimates': '57.8 K',
                'Within 5% of Sale Price': '69.46%',
                'Within 10% of Sale Price': '90.16%',
                'Within 20% of Sale Price': '98.02%',
            },
            {
                State: 'North Carolina',
                'Median Error': '1.44%',
                'Homes With Zestimates': '78.0 K',
                'Within 5% of Sale Price': '88.68%',
                'Within 10% of Sale Price': '96.64%',
                'Within 20% of Sale Price': '98.98%',
            },
            {
                State: 'North Dakota',
                'Median Error': '1.53%',
                'Homes With Zestimates': '3.6 K',
                'Within 5% of Sale Price': '87.85%',
                'Within 10% of Sale Price': '96.66%',
                'Within 20% of Sale Price': '98.87%',
            },
            {
                State: 'Ohio',
                'Median Error': '2.16%',
                'Homes With Zestimates': '47.7 K',
                'Within 5% of Sale Price': '80.41%',
                'Within 10% of Sale Price': '94.61%',
                'Within 20% of Sale Price': '98.54%',
            },
            {
                State: 'Oklahoma',
                'Median Error': '1.74%',
                'Homes With Zestimates': '26.5 K',
                'Within 5% of Sale Price': '85.04%',
                'Within 10% of Sale Price': '95.42%',
                'Within 20% of Sale Price': '98.61%',
            },
            {
                State: 'Oregon',
                'Median Error': '1.51%',
                'Homes With Zestimates': '27.2 K',
                'Within 5% of Sale Price': '88.90%',
                'Within 10% of Sale Price': '97.15%',
                'Within 20% of Sale Price': '99.18%',
            },
            {
                State: 'Pennsylvania',
                'Median Error': '2.31%',
                'Homes With Zestimates': '44.1 K',
                'Within 5% of Sale Price': '77.82%',
                'Within 10% of Sale Price': '93.78%',
                'Within 20% of Sale Price': '98.57%',
            },
            {
                State: 'Rhode Island',
                'Median Error': '2.42%',
                'Homes With Zestimates': '4.6 K',
                'Within 5% of Sale Price': '78.20%',
                'Within 10% of Sale Price': '94.83%',
                'Within 20% of Sale Price': '98.96%',
            },
            {
                State: 'South Carolina',
                'Median Error': '1.50%',
                'Homes With Zestimates': '49.5 K',
                'Within 5% of Sale Price': '88.63%',
                'Within 10% of Sale Price': '96.79%',
                'Within 20% of Sale Price': '99.11%',
            },
            {
                State: 'South Dakota',
                'Median Error': '1.75%',
                'Homes With Zestimates': '5.9 K',
                'Within 5% of Sale Price': '85.64%',
                'Within 10% of Sale Price': '96.00%',
                'Within 20% of Sale Price': '99.07%',
            },
            {
                State: 'Tennessee',
                'Median Error': '1.67%',
                'Homes With Zestimates': '55.1 K',
                'Within 5% of Sale Price': '85.30%',
                'Within 10% of Sale Price': '95.03%',
                'Within 20% of Sale Price': '98.25%',
            },
            {
                State: 'Texas',
                'Median Error': '1.83%',
                'Homes With Zestimates': '255.2 K',
                'Within 5% of Sale Price': '84.86%',
                'Within 10% of Sale Price': '95.22%',
                'Within 20% of Sale Price': '98.68%',
            },
            {
                State: 'Utah',
                'Median Error': '1.23%',
                'Homes With Zestimates': '27.9 K',
                'Within 5% of Sale Price': '92.21%',
                'Within 10% of Sale Price': '98.16%',
                'Within 20% of Sale Price': '99.54%',
            },
            {
                State: 'Vermont',
                'Median Error': '2.43%',
                'Homes With Zestimates': '3.5 K',
                'Within 5% of Sale Price': '76.86%',
                'Within 10% of Sale Price': '92.45%',
                'Within 20% of Sale Price': '98.15%',
            },
            {
                State: 'Virginia',
                'Median Error': '1.49%',
                'Homes With Zestimates': '35.6 K',
                'Within 5% of Sale Price': '88.12%',
                'Within 10% of Sale Price': '96.92%',
                'Within 20% of Sale Price': '99.16%',
            },
            {
                State: 'Washington',
                'Median Error': '1.51%',
                'Homes With Zestimates': '42.5 K',
                'Within 5% of Sale Price': '88.31%',
                'Within 10% of Sale Price': '96.86%',
                'Within 20% of Sale Price': '99.25%',
            },
            {
                State: 'West Virginia',
                'Median Error': '2.19%',
                'Homes With Zestimates': '5.5 K',
                'Within 5% of Sale Price': '78.87%',
                'Within 10% of Sale Price': '93.64%',
                'Within 20% of Sale Price': '98.12%',
            },
            {
                State: 'Wisconsin',
                'Median Error': '2.43%',
                'Homes With Zestimates': '21.8 K',
                'Within 5% of Sale Price': '76.99%',
                'Within 10% of Sale Price': '94.15%',
                'Within 20% of Sale Price': '98.90%',
            },
            {
                State: 'Wyoming',
                'Median Error': '1.63%',
                'Homes With Zestimates': '3.9 K',
                'Within 5% of Sale Price': '86.77%',
                'Within 10% of Sale Price': '96.22%',
                'Within 20% of Sale Price': '99.01%',
            },
        ],
    },
    National: {
        headers: [
            'Region',
            'Median Error<sup>*</sup>',
            'Homes With Zestimates<sup>**</sup>',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                Region: 'All 50 States',
                'Median Error': '1.83%',
                'Homes With Zestimates': '1.9 M',
                'Within 5% of Sale Price': '83.95%',
                'Within 10% of Sale Price': '95.39%',
                'Within 20% of Sale Price': '98.83%',
            },
        ],
    },
};

/**
 * Zestimate accuracy data for off-market homes
 */
export const ZESTIMATE_DATA_OFF_MARKET: Record<string, ZestimateTableData> = {
    'Top Metro Areas': {
        headers: [
            'Metropolitan Area',
            'Median Error<sup>*</sup>',
            'Homes With Zestimates<sup>**</sup>',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                'Metropolitan Area': 'Atlanta',
                'Median Error': '6.25%',
                'Homes With Zestimates': '2.2 M',
                'Within 5% of Sale Price': '42.12%',
                'Within 10% of Sale Price': '67.58%',
                'Within 20% of Sale Price': '87.39%',
            },
            {
                'Metropolitan Area': 'Austin',
                'Median Error': '6.20%',
                'Homes With Zestimates': '848.7 K',
                'Within 5% of Sale Price': '42.02%',
                'Within 10% of Sale Price': '68.79%',
                'Within 20% of Sale Price': '89.45%',
            },
            {
                'Metropolitan Area': 'Baltimore',
                'Median Error': '5.82%',
                'Homes With Zestimates': '940.0 K',
                'Within 5% of Sale Price': '45.15%',
                'Within 10% of Sale Price': '68.59%',
                'Within 20% of Sale Price': '86.42%',
            },
            {
                'Metropolitan Area': 'Boston',
                'Median Error': '6.74%',
                'Homes With Zestimates': '1.6 M',
                'Within 5% of Sale Price': '39.12%',
                'Within 10% of Sale Price': '65.77%',
                'Within 20% of Sale Price': '87.41%',
            },
            {
                'Metropolitan Area': 'Charlotte',
                'Median Error': '5.68%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '45.38%',
                'Within 10% of Sale Price': '70.76%',
                'Within 20% of Sale Price': '88.98%',
            },
            {
                'Metropolitan Area': 'Chicago',
                'Median Error': '7.13%',
                'Homes With Zestimates': '3.3 M',
                'Within 5% of Sale Price': '37.65%',
                'Within 10% of Sale Price': '63.01%',
                'Within 20% of Sale Price': '84.75%',
            },
            {
                'Metropolitan Area': 'Cincinnati',
                'Median Error': '7.45%',
                'Homes With Zestimates': '811.2 K',
                'Within 5% of Sale Price': '36.43%',
                'Within 10% of Sale Price': '61.08%',
                'Within 20% of Sale Price': '82.58%',
            },
            {
                'Metropolitan Area': 'Cleveland',
                'Median Error': '9.00%',
                'Homes With Zestimates': '765.3 K',
                'Within 5% of Sale Price': '30.47%',
                'Within 10% of Sale Price': '54.35%',
                'Within 20% of Sale Price': '79.53%',
            },
            {
                'Metropolitan Area': 'Colorado Springs',
                'Median Error': '4.67%',
                'Homes With Zestimates': '272.6 K',
                'Within 5% of Sale Price': '52.75%',
                'Within 10% of Sale Price': '77.61%',
                'Within 20% of Sale Price': '92.70%',
            },
            {
                'Metropolitan Area': 'Dallas-Fort Worth',
                'Median Error': '5.62%',
                'Homes With Zestimates': '2.5 M',
                'Within 5% of Sale Price': '45.64%',
                'Within 10% of Sale Price': '72.02%',
                'Within 20% of Sale Price': '90.00%',
            },
            {
                'Metropolitan Area': 'Denver',
                'Median Error': '4.89%',
                'Homes With Zestimates': '1.0 M',
                'Within 5% of Sale Price': '50.88%',
                'Within 10% of Sale Price': '76.66%',
                'Within 20% of Sale Price': '92.60%',
            },
            {
                'Metropolitan Area': 'Detroit',
                'Median Error': '7.92%',
                'Homes With Zestimates': '1.5 M',
                'Within 5% of Sale Price': '34.76%',
                'Within 10% of Sale Price': '58.68%',
                'Within 20% of Sale Price': '81.01%',
            },
            {
                'Metropolitan Area': 'Fort Collins',
                'Median Error': '5.05%',
                'Homes With Zestimates': '146.9 K',
                'Within 5% of Sale Price': '49.66%',
                'Within 10% of Sale Price': '75.34%',
                'Within 20% of Sale Price': '92.37%',
            },
            {
                'Metropolitan Area': 'Houston',
                'Median Error': '6.19%',
                'Homes With Zestimates': '2.4 M',
                'Within 5% of Sale Price': '42.33%',
                'Within 10% of Sale Price': '68.10%',
                'Within 20% of Sale Price': '88.23%',
            },
            {
                'Metropolitan Area': 'Jacksonville',
                'Median Error': '6.13%',
                'Homes With Zestimates': '702.6 K',
                'Within 5% of Sale Price': '42.76%',
                'Within 10% of Sale Price': '68.15%',
                'Within 20% of Sale Price': '86.93%',
            },
            {
                'Metropolitan Area': 'Kansas City',
                'Median Error': '6.60%',
                'Homes With Zestimates': '815.4 K',
                'Within 5% of Sale Price': '40.05%',
                'Within 10% of Sale Price': '66.00%',
                'Within 20% of Sale Price': '86.36%',
            },
            {
                'Metropolitan Area': 'Las Vegas',
                'Median Error': '4.27%',
                'Homes With Zestimates': '818.2 K',
                'Within 5% of Sale Price': '56.21%',
                'Within 10% of Sale Price': '80.03%',
                'Within 20% of Sale Price': '92.75%',
            },
            {
                'Metropolitan Area': 'Los Angeles-Long Beach-Anaheim',
                'Median Error': '6.55%',
                'Homes With Zestimates': '3.0 M',
                'Within 5% of Sale Price': '40.54%',
                'Within 10% of Sale Price': '66.12%',
                'Within 20% of Sale Price': '86.94%',
            },
            {
                'Metropolitan Area': 'Miami-Fort Lauderdale',
                'Median Error': '7.43%',
                'Homes With Zestimates': '2.5 M',
                'Within 5% of Sale Price': '36.36%',
                'Within 10% of Sale Price': '61.46%',
                'Within 20% of Sale Price': '84.59%',
            },
            {
                'Metropolitan Area': 'Minneapolis-St Paul',
                'Median Error': '5.75%',
                'Homes With Zestimates': '1.4 M',
                'Within 5% of Sale Price': '44.77%',
                'Within 10% of Sale Price': '71.35%',
                'Within 20% of Sale Price': '90.11%',
            },
            {
                'Metropolitan Area': 'Nashville',
                'Median Error': '6.45%',
                'Homes With Zestimates': '885.1 K',
                'Within 5% of Sale Price': '41.07%',
                'Within 10% of Sale Price': '66.08%',
                'Within 20% of Sale Price': '84.91%',
            },
            {
                'Metropolitan Area': 'New York',
                'Median Error': '7.80%',
                'Homes With Zestimates': '5.5 M',
                'Within 5% of Sale Price': '35.23%',
                'Within 10% of Sale Price': '59.61%',
                'Within 20% of Sale Price': '83.32%',
            },
            {
                'Metropolitan Area': 'Orlando',
                'Median Error': '5.49%',
                'Homes With Zestimates': '973.6 K',
                'Within 5% of Sale Price': '46.77%',
                'Within 10% of Sale Price': '72.11%',
                'Within 20% of Sale Price': '89.89%',
            },
            {
                'Metropolitan Area': 'Philadelphia',
                'Median Error': '7.71%',
                'Homes With Zestimates': '2.1 M',
                'Within 5% of Sale Price': '35.31%',
                'Within 10% of Sale Price': '59.67%',
                'Within 20% of Sale Price': '82.68%',
            },
            {
                'Metropolitan Area': 'Phoenix',
                'Median Error': '5.13%',
                'Homes With Zestimates': '1.7 M',
                'Within 5% of Sale Price': '49.15%',
                'Within 10% of Sale Price': '74.36%',
                'Within 20% of Sale Price': '90.61%',
            },
            {
                'Metropolitan Area': 'Pittsburgh',
                'Median Error': '11.37%',
                'Homes With Zestimates': '880.6 K',
                'Within 5% of Sale Price': '26.11%',
                'Within 10% of Sale Price': '45.67%',
                'Within 20% of Sale Price': '69.76%',
            },
            {
                'Metropolitan Area': 'Portland',
                'Median Error': '5.55%',
                'Homes With Zestimates': '864.0 K',
                'Within 5% of Sale Price': '46.08%',
                'Within 10% of Sale Price': '72.18%',
                'Within 20% of Sale Price': '89.98%',
            },
            {
                'Metropolitan Area': 'Raleigh',
                'Median Error': '4.62%',
                'Homes With Zestimates': '541.7 K',
                'Within 5% of Sale Price': '53.18%',
                'Within 10% of Sale Price': '78.98%',
                'Within 20% of Sale Price': '93.11%',
            },
            {
                'Metropolitan Area': 'Riverside',
                'Median Error': '5.57%',
                'Homes With Zestimates': '1.4 M',
                'Within 5% of Sale Price': '46.23%',
                'Within 10% of Sale Price': '69.87%',
                'Within 20% of Sale Price': '86.15%',
            },
            {
                'Metropolitan Area': 'Sacramento',
                'Median Error': '5.36%',
                'Homes With Zestimates': '793.5 K',
                'Within 5% of Sale Price': '47.35%',
                'Within 10% of Sale Price': '72.55%',
                'Within 20% of Sale Price': '89.48%',
            },
            {
                'Metropolitan Area': 'San Antonio',
                'Median Error': '6.54%',
                'Homes With Zestimates': '958.6 K',
                'Within 5% of Sale Price': '40.47%',
                'Within 10% of Sale Price': '65.77%',
                'Within 20% of Sale Price': '86.59%',
            },
            {
                'Metropolitan Area': 'San Diego',
                'Median Error': '5.92%',
                'Homes With Zestimates': '918.4 K',
                'Within 5% of Sale Price': '43.82%',
                'Within 10% of Sale Price': '69.67%',
                'Within 20% of Sale Price': '88.85%',
            },
            {
                'Metropolitan Area': 'San Francisco',
                'Median Error': '7.81%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '34.74%',
                'Within 10% of Sale Price': '59.88%',
                'Within 20% of Sale Price': '84.46%',
            },
            {
                'Metropolitan Area': 'Seattle',
                'Median Error': '5.65%',
                'Homes With Zestimates': '1.4 M',
                'Within 5% of Sale Price': '45.33%',
                'Within 10% of Sale Price': '71.80%',
                'Within 20% of Sale Price': '90.48%',
            },
            {
                'Metropolitan Area': 'St. Louis',
                'Median Error': '8.07%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '34.31%',
                'Within 10% of Sale Price': '57.87%',
                'Within 20% of Sale Price': '80.61%',
            },
            {
                'Metropolitan Area': 'Tampa',
                'Median Error': '7.14%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '37.53%',
                'Within 10% of Sale Price': '62.47%',
                'Within 20% of Sale Price': '83.99%',
            },
            {
                'Metropolitan Area': 'Tucson',
                'Median Error': '5.85%',
                'Homes With Zestimates': '386.1 K',
                'Within 5% of Sale Price': '44.40%',
                'Within 10% of Sale Price': '69.39%',
                'Within 20% of Sale Price': '88.42%',
            },
            {
                'Metropolitan Area': 'Washington',
                'Median Error': '4.83%',
                'Homes With Zestimates': '2.0 M',
                'Within 5% of Sale Price': '51.34%',
                'Within 10% of Sale Price': '76.78%',
                'Within 20% of Sale Price': '92.17%',
            },
        ],
    },
    States: {
        headers: [
            'State',
            'Median Error<sup>*</sup>',
            'Homes With Zestimates<sup>**</sup>',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                State: 'Alabama',
                'Median Error': '7.69%',
                'Homes With Zestimates': '1.8 M',
                'Within 5% of Sale Price': '36.54%',
                'Within 10% of Sale Price': '58.74%',
                'Within 20% of Sale Price': '78.72%',
            },
            {
                State: 'Alaska',
                'Median Error': 'NA',
                'Homes With Zestimates': '242.7 K',
                'Within 5% of Sale Price': 'NA',
                'Within 10% of Sale Price': 'NA',
                'Within 20% of Sale Price': 'NA',
            },
            {
                State: 'Arizona',
                'Median Error': '5.68%',
                'Homes With Zestimates': '2.7 M',
                'Within 5% of Sale Price': '45.55%',
                'Within 10% of Sale Price': '70.29%',
                'Within 20% of Sale Price': '88.09%',
            },
            {
                State: 'Arkansas',
                'Median Error': '7.82%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '36.35%',
                'Within 10% of Sale Price': '57.59%',
                'Within 20% of Sale Price': '76.99%',
            },
            {
                State: 'California',
                'Median Error': '6.34%',
                'Homes With Zestimates': '10.8 M',
                'Within 5% of Sale Price': '41.74%',
                'Within 10% of Sale Price': '66.48%',
                'Within 20% of Sale Price': '85.95%',
            },
            {
                State: 'Colorado',
                'Median Error': '5.38%',
                'Homes With Zestimates': '2.2 M',
                'Within 5% of Sale Price': '47.39%',
                'Within 10% of Sale Price': '72.47%',
                'Within 20% of Sale Price': '89.87%',
            },
            {
                State: 'Connecticut',
                'Median Error': '7.98%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '33.37%',
                'Within 10% of Sale Price': '59.18%',
                'Within 20% of Sale Price': '83.93%',
            },
            {
                State: 'Delaware',
                'Median Error': '8.96%',
                'Homes With Zestimates': '438.6 K',
                'Within 5% of Sale Price': '31.05%',
                'Within 10% of Sale Price': '54.07%',
                'Within 20% of Sale Price': '79.21%',
            },
            {
                State: 'District of Columbia',
                'Median Error': '7.60%',
                'Homes With Zestimates': '193.2 K',
                'Within 5% of Sale Price': '36.17%',
                'Within 10% of Sale Price': '60.45%',
                'Within 20% of Sale Price': '83.43%',
            },
            {
                State: 'Florida',
                'Median Error': '7.00%',
                'Homes With Zestimates': '9.5 M',
                'Within 5% of Sale Price': '38.53%',
                'Within 10% of Sale Price': '63.25%',
                'Within 20% of Sale Price': '84.70%',
            },
            {
                State: 'Georgia',
                'Median Error': '6.73%',
                'Homes With Zestimates': '3.8 M',
                'Within 5% of Sale Price': '40.00%',
                'Within 10% of Sale Price': '64.01%',
                'Within 20% of Sale Price': '83.57%',
            },
            {
                State: 'Hawaii',
                'Median Error': '7.94%',
                'Homes With Zestimates': '530.9 K',
                'Within 5% of Sale Price': '34.47%',
                'Within 10% of Sale Price': '58.59%',
                'Within 20% of Sale Price': '81.75%',
            },
            {
                State: 'Idaho',
                'Median Error': '5.60%',
                'Homes With Zestimates': '836.0 K',
                'Within 5% of Sale Price': '45.99%',
                'Within 10% of Sale Price': '70.98%',
                'Within 20% of Sale Price': '89.44%',
            },
            {
                State: 'Illinois',
                'Median Error': '8.16%',
                'Homes With Zestimates': '4.4 M',
                'Within 5% of Sale Price': '33.83%',
                'Within 10% of Sale Price': '57.54%',
                'Within 20% of Sale Price': '80.00%',
            },
            {
                State: 'Indiana',
                'Median Error': '7.30%',
                'Homes With Zestimates': '2.5 M',
                'Within 5% of Sale Price': '37.05%',
                'Within 10% of Sale Price': '61.23%',
                'Within 20% of Sale Price': '81.71%',
            },
            {
                State: 'Iowa',
                'Median Error': '7.74%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '35.37%',
                'Within 10% of Sale Price': '59.04%',
                'Within 20% of Sale Price': '80.79%',
            },
            {
                State: 'Kansas',
                'Median Error': '7.41%',
                'Homes With Zestimates': '1.0 M',
                'Within 5% of Sale Price': '36.69%',
                'Within 10% of Sale Price': '61.25%',
                'Within 20% of Sale Price': '82.46%',
            },
            {
                State: 'Kentucky',
                'Median Error': '7.98%',
                'Homes With Zestimates': '1.5 M',
                'Within 5% of Sale Price': '34.85%',
                'Within 10% of Sale Price': '57.96%',
                'Within 20% of Sale Price': '79.09%',
            },
            {
                State: 'Louisiana',
                'Median Error': '8.77%',
                'Homes With Zestimates': '1.5 M',
                'Within 5% of Sale Price': '33.59%',
                'Within 10% of Sale Price': '54.36%',
                'Within 20% of Sale Price': '74.75%',
            },
            {
                State: 'Maine',
                'Median Error': '10.24%',
                'Homes With Zestimates': '505.7 K',
                'Within 5% of Sale Price': '27.20%',
                'Within 10% of Sale Price': '49.24%',
                'Within 20% of Sale Price': '73.70%',
            },
            {
                State: 'Maryland',
                'Median Error': '5.79%',
                'Homes With Zestimates': '2.1 M',
                'Within 5% of Sale Price': '45.13%',
                'Within 10% of Sale Price': '69.18%',
                'Within 20% of Sale Price': '86.97%',
            },
            {
                State: 'Massachusetts',
                'Median Error': '6.99%',
                'Homes With Zestimates': '2.3 M',
                'Within 5% of Sale Price': '38.03%',
                'Within 10% of Sale Price': '64.03%',
                'Within 20% of Sale Price': '86.11%',
            },
            {
                State: 'Michigan',
                'Median Error': '8.78%',
                'Homes With Zestimates': '3.9 M',
                'Within 5% of Sale Price': '31.98%',
                'Within 10% of Sale Price': '54.68%',
                'Within 20% of Sale Price': '77.70%',
            },
            {
                State: 'Minnesota',
                'Median Error': '6.58%',
                'Homes With Zestimates': '2.2 M',
                'Within 5% of Sale Price': '40.24%',
                'Within 10% of Sale Price': '65.42%',
                'Within 20% of Sale Price': '85.91%',
            },
            {
                State: 'Mississippi',
                'Median Error': '6.94%',
                'Homes With Zestimates': '873.3 K',
                'Within 5% of Sale Price': '40.01%',
                'Within 10% of Sale Price': '61.50%',
                'Within 20% of Sale Price': '79.99%',
            },
            {
                State: 'Missouri',
                'Median Error': '8.06%',
                'Homes With Zestimates': '2.4 M',
                'Within 5% of Sale Price': '34.30%',
                'Within 10% of Sale Price': '57.73%',
                'Within 20% of Sale Price': '80.14%',
            },
            {
                State: 'Montana',
                'Median Error': '8.02%',
                'Homes With Zestimates': '455.1 K',
                'Within 5% of Sale Price': '34.29%',
                'Within 10% of Sale Price': '58.26%',
                'Within 20% of Sale Price': '80.56%',
            },
            {
                State: 'Nebraska',
                'Median Error': '6.37%',
                'Homes With Zestimates': '682.8 K',
                'Within 5% of Sale Price': '41.86%',
                'Within 10% of Sale Price': '66.22%',
                'Within 20% of Sale Price': '85.22%',
            },
            {
                State: 'Nevada',
                'Median Error': '4.54%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '53.49%',
                'Within 10% of Sale Price': '77.40%',
                'Within 20% of Sale Price': '91.32%',
            },
            {
                State: 'New Hampshire',
                'Median Error': '7.52%',
                'Homes With Zestimates': '601.8 K',
                'Within 5% of Sale Price': '35.62%',
                'Within 10% of Sale Price': '60.68%',
                'Within 20% of Sale Price': '83.17%',
            },
            {
                State: 'New Jersey',
                'Median Error': '7.47%',
                'Homes With Zestimates': '3.0 M',
                'Within 5% of Sale Price': '36.45%',
                'Within 10% of Sale Price': '61.18%',
                'Within 20% of Sale Price': '84.06%',
            },
            {
                State: 'New Mexico',
                'Median Error': '6.41%',
                'Homes With Zestimates': '706.7 K',
                'Within 5% of Sale Price': '41.76%',
                'Within 10% of Sale Price': '65.59%',
                'Within 20% of Sale Price': '84.79%',
            },
            {
                State: 'New York',
                'Median Error': '9.31%',
                'Homes With Zestimates': '5.6 M',
                'Within 5% of Sale Price': '30.24%',
                'Within 10% of Sale Price': '52.66%',
                'Within 20% of Sale Price': '77.26%',
            },
            {
                State: 'North Carolina',
                'Median Error': '6.22%',
                'Homes With Zestimates': '4.2 M',
                'Within 5% of Sale Price': '42.59%',
                'Within 10% of Sale Price': '66.55%',
                'Within 20% of Sale Price': '84.78%',
            },
            {
                State: 'North Dakota',
                'Median Error': '6.79%',
                'Homes With Zestimates': '225.2 K',
                'Within 5% of Sale Price': '39.15%',
                'Within 10% of Sale Price': '63.58%',
                'Within 20% of Sale Price': '83.82%',
            },
            {
                State: 'Ohio',
                'Median Error': '8.55%',
                'Homes With Zestimates': '4.3 M',
                'Within 5% of Sale Price': '32.61%',
                'Within 10% of Sale Price': '55.68%',
                'Within 20% of Sale Price': '78.33%',
            },
            {
                State: 'Oklahoma',
                'Median Error': '7.18%',
                'Homes With Zestimates': '1.5 M',
                'Within 5% of Sale Price': '38.37%',
                'Within 10% of Sale Price': '60.73%',
                'Within 20% of Sale Price': '79.77%',
            },
            {
                State: 'Oregon',
                'Median Error': '6.28%',
                'Homes With Zestimates': '1.6 M',
                'Within 5% of Sale Price': '42.03%',
                'Within 10% of Sale Price': '67.13%',
                'Within 20% of Sale Price': '86.46%',
            },
            {
                State: 'Pennsylvania',
                'Median Error': '9.25%',
                'Homes With Zestimates': '4.6 M',
                'Within 5% of Sale Price': '30.64%',
                'Within 10% of Sale Price': '52.79%',
                'Within 20% of Sale Price': '76.01%',
            },
            {
                State: 'Rhode Island',
                'Median Error': '7.11%',
                'Homes With Zestimates': '368.9 K',
                'Within 5% of Sale Price': '37.45%',
                'Within 10% of Sale Price': '63.50%',
                'Within 20% of Sale Price': '86.10%',
            },
            {
                State: 'South Carolina',
                'Median Error': '6.65%',
                'Homes With Zestimates': '2.1 M',
                'Within 5% of Sale Price': '40.50%',
                'Within 10% of Sale Price': '64.50%',
                'Within 20% of Sale Price': '84.10%',
            },
            {
                State: 'South Dakota',
                'Median Error': '7.76%',
                'Homes With Zestimates': '305.3 K',
                'Within 5% of Sale Price': '36.23%',
                'Within 10% of Sale Price': '60.00%',
                'Within 20% of Sale Price': '81.68%',
            },
            {
                State: 'Tennessee',
                'Median Error': '8.06%',
                'Homes With Zestimates': '2.8 M',
                'Within 5% of Sale Price': '34.97%',
                'Within 10% of Sale Price': '57.10%',
                'Within 20% of Sale Price': '76.88%',
            },
            {
                State: 'Texas',
                'Median Error': '6.40%',
                'Homes With Zestimates': '10.0 M',
                'Within 5% of Sale Price': '41.26%',
                'Within 10% of Sale Price': '66.52%',
                'Within 20% of Sale Price': '86.33%',
            },
            {
                State: 'Utah',
                'Median Error': '5.13%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '49.02%',
                'Within 10% of Sale Price': '74.91%',
                'Within 20% of Sale Price': '91.69%',
            },
            {
                State: 'Vermont',
                'Median Error': '12.03%',
                'Homes With Zestimates': '271.6 K',
                'Within 5% of Sale Price': '24.34%',
                'Within 10% of Sale Price': '44.04%',
                'Within 20% of Sale Price': '67.80%',
            },
            {
                State: 'Virginia',
                'Median Error': '5.53%',
                'Homes With Zestimates': '3.0 M',
                'Within 5% of Sale Price': '46.41%',
                'Within 10% of Sale Price': '70.97%',
                'Within 20% of Sale Price': '87.73%',
            },
            {
                State: 'Washington',
                'Median Error': '5.92%',
                'Homes With Zestimates': '2.8 M',
                'Within 5% of Sale Price': '43.97%',
                'Within 10% of Sale Price': '68.92%',
                'Within 20% of Sale Price': '87.59%',
            },
            {
                State: 'West Virginia',
                'Median Error': '10.00%',
                'Homes With Zestimates': '618.8 K',
                'Within 5% of Sale Price': '29.33%',
                'Within 10% of Sale Price': '50.02%',
                'Within 20% of Sale Price': '71.51%',
            },
            {
                State: 'Wisconsin',
                'Median Error': '7.83%',
                'Homes With Zestimates': '2.2 M',
                'Within 5% of Sale Price': '34.98%',
                'Within 10% of Sale Price': '59.18%',
                'Within 20% of Sale Price': '81.53%',
            },
            {
                State: 'Wyoming',
                'Median Error': '8.01%',
                'Homes With Zestimates': '236.4 K',
                'Within 5% of Sale Price': '34.38%',
                'Within 10% of Sale Price': '58.64%',
                'Within 20% of Sale Price': '81.33%',
            },
        ],
    },
    National: {
        headers: [
            'Region',
            'Median Error<sup>*</sup>',
            'Homes With Zestimates<sup>**</sup>',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                Region: 'All 50 States',
                'Median Error': '7.01%',
                'Homes With Zestimates': '116.3 M',
                'Within 5% of Sale Price': '38.69%',
                'Within 10% of Sale Price': '62.71%',
                'Within 20% of Sale Price': '83.20%',
            },
        ],
    },
};
